module.exports = __webpack_public_path__ + "static/washington-2172fb1e0b63da8bbb74afb949f676a3.jpg";